// src/api/leavePolicyApi.js
import apiClient from './axios';

const leavePolicyApi = {
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/leave-policy/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  create: async (data) => {
    const response = await apiClient.post('/leave-policy/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/leave-policy/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/leave-policy/${id}/`);
    return id;
  },

  exportCsv: async () => {
    const response = await apiClient.get('/leave-policy/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/leave-policy/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post('/leave-policy/import-confirm/', { preview });
    return response.data;
  },
};

export default leavePolicyApi;